import type { PropsWithChildren, ReactNode } from 'react';

type TipsenSheetContentProps = PropsWithChildren<{ className?: string }>;

/**
 * TipsenSheet content wrapper.
 *
 * @param root0 root
 * @param root0.children the children to pass down
 * @param root0.className optional class name to apply to the content wrapper
 * @returns TipsenSheet content wrapper.
 */
export default function TipsenSheetContent({ children, className }: TipsenSheetContentProps): ReactNode {
  return <div className={className}>{children}</div>;
}
